/**
 * ELORIA Luxury Jewelry Maison Theme JS
 * Upgraded with Premium Micro-interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initStickyHeader();
  initLoupeCursor();
  initSpotlightEffect();
  initLoupePrecisionSection();
  initProductGallery();
  initProductVariants();
  initCartDrawer();
  initCollectionCarousels();
  initHeroCarousel();
});

/**
 * Collection hero slideshow (fade + dots + swipe)
 */
function initHeroCarousel() {
  const hero = document.querySelector('[data-hero]');
  if (!hero) return;
  const slides = hero.querySelectorAll('.collection-hero-slide');
  const dotsWrap = hero.querySelector('[data-hero-dots]');
  if (slides.length <= 1) { if (dotsWrap) dotsWrap.style.display = 'none'; return; }

  let idx = 0;
  slides.forEach((s, i) => {
    const b = document.createElement('button');
    b.className = 'collection-hero-dot' + (i === 0 ? ' is-active' : '');
    b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    b.addEventListener('click', () => { go(i); restart(); });
    dotsWrap.appendChild(b);
  });
  const dots = dotsWrap.querySelectorAll('.collection-hero-dot');

  function go(n) {
    slides[idx].classList.remove('is-active');
    dots[idx].classList.remove('is-active');
    idx = (n + slides.length) % slides.length;
    slides[idx].classList.add('is-active');
    dots[idx].classList.add('is-active');
  }

  let timer = setInterval(() => go(idx + 1), 5000);
  function restart() { clearInterval(timer); timer = setInterval(() => go(idx + 1), 5000); }

  // Touch swipe
  let sx = 0;
  hero.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
  hero.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - sx;
    if (Math.abs(dx) > 40) { go(dx < 0 ? idx + 1 : idx - 1); restart(); }
  }, { passive: true });
}

/**
 * Horizontal collection carousels (Collections Showcase page)
 */
function initCollectionCarousels() {
  document.querySelectorAll('.carousel-arrow').forEach(btn => {
    btn.addEventListener('click', () => {
      const track = document.getElementById(btn.dataset.target);
      if (!track) return;
      const item = track.querySelector('.carousel-item');
      const step = item ? item.getBoundingClientRect().width + 32 : track.clientWidth * 0.8;
      const dir = btn.classList.contains('carousel-prev') ? -1 : 1;
      track.scrollBy({ left: step * dir, behavior: 'smooth' });
    });
  });
}

/**
 * 1. Scroll animations using Intersection Observer
 */
function initScrollAnimations() {
  const observerOptions = {
    threshold: 0.08,
    rootMargin: '0px 0px -60px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-delay') || 0;
        setTimeout(() => {
          entry.target.classList.add('visible');
          entry.target.classList.add('active');
        }, delay);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.stagger-load, .reveal-up').forEach(el => observer.observe(el));
}

/**
 * 2. Sticky navigation bar logic (Hide on scroll down, show on scroll up, shrink)
 */
function initStickyHeader() {
  let lastScroll = 0;
  const nav = document.querySelector('nav');
  if (!nav) return;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    // Add/remove shrink state
    if (currentScroll > 40) {
      nav.classList.add('h-16');
      nav.classList.remove('h-20');
      nav.style.backgroundColor = 'rgba(5, 5, 5, 0.9)';
      nav.style.borderBottomColor = 'rgba(255, 255, 255, 0.08)';
    } else {
      nav.classList.remove('h-16');
      nav.classList.add('h-20');
      nav.style.backgroundColor = 'rgba(5, 5, 5, 0.7)';
      nav.style.borderBottomColor = 'rgba(255, 255, 255, 0.04)';
    }

    // Hide/show on scroll direction change
    if (currentScroll <= 0) {
      nav.style.transform = 'translateY(0)';
      return;
    }
    if (currentScroll > lastScroll && currentScroll > 80) {
      // Scroll Down
      nav.style.transform = 'translateY(-100%)';
    } else {
      // Scroll Up
      nav.style.transform = 'translateY(0)';
    }
    lastScroll = currentScroll;
  });
}

/**
 * 3. Concentric Ring Loupe Cursor
 */
function initLoupeCursor() {
  const loupe = document.getElementById('loupe') || document.getElementById('cursor') || document.getElementById('custom-cursor');
  if (!loupe) return;

  document.addEventListener('mousemove', (e) => {
    loupe.style.left = e.clientX + 'px';
    loupe.style.top = e.clientY + 'px';
  });

  // Activate hover effect on specific areas (causes concentric rings to scale out)
  const hoverAreas = document.querySelectorAll('.hover-area, #loupe-trigger, .product-card-image-wrapper, .btn-primary, .btn-secondary');
  hoverAreas.forEach(area => {
    area.addEventListener('mouseenter', () => {
      loupe.style.display = 'block';
      setTimeout(() => {
        loupe.style.transform = 'translate(-50%, -50%) scale(1.4)';
        loupe.style.borderColor = 'rgba(255, 255, 255, 0.75)';
        loupe.style.backgroundColor = 'rgba(255, 255, 255, 0.04)';
      }, 10);
    });

    area.addEventListener('mouseleave', () => {
      loupe.style.transform = 'translate(-50%, -50%) scale(1)';
      loupe.style.borderColor = 'rgba(255, 255, 255, 0.25)';
      loupe.style.backgroundColor = 'rgba(255, 255, 255, 0.01)';
      setTimeout(() => {
        if (!area.matches(':hover')) {
          loupe.style.display = 'none';
        }
      }, 150);
    });
  });
}

/**
 * 4. Dynamic Spotlight Reflection Effect
 */
function initSpotlightEffect() {
  // Add spotlight wrapper to glass panels, product cards, etc.
  const spotlightBlocks = document.querySelectorAll('.glass-panel, .glass-panel-deep, .product-card, .cart-drawer-item, .size-selector-btn');
  
  spotlightBlocks.forEach(block => {
    block.classList.add('hover-spotlight');
    block.addEventListener('mousemove', (e) => {
      const rect = block.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      block.style.setProperty('--mouse-x', `${x}%`);
      block.style.setProperty('--mouse-y', `${y}%`);
    });
  });
}

/**
 * 5. Magnifying Detail Zoom banner (Loupe Precision Section)
 */
function initLoupePrecisionSection() {
  const container = document.getElementById('loupe-container');
  const image = document.getElementById('loupe-image');
  const circle = document.getElementById('loupe-circle');
  if (!container || !image || !circle) return;

  container.addEventListener('mousemove', (e) => {
    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    circle.style.display = 'block';
    circle.style.left = `${x - 80}px`;
    circle.style.top = `${y - 80}px`;

    // Zoom math
    const zoomLevel = 2.5;
    const imgRect = image.getBoundingClientRect();
    const imgX = (x - (imgRect.left - rect.left)) / imgRect.width;
    const imgY = (y - (imgRect.top - rect.top)) / imgRect.height;

    const zoomSrc = image.dataset.zoomSrc || image.currentSrc || image.src;
    circle.style.backgroundImage = `url(${zoomSrc})`;
    circle.style.backgroundSize = `${imgRect.width * zoomLevel}px ${imgRect.height * zoomLevel}px`;
    circle.style.backgroundPosition = `-${(imgX * imgRect.width * zoomLevel) - 80}px -${(imgY * imgRect.height * zoomLevel) - 80}px`;
  });

  container.addEventListener('mouseleave', () => {
    circle.style.display = 'none';
  });
}

/**
 * 6. Product Gallery Thumbnails
 */
function initProductGallery() {
  const mainImage = document.querySelector('section img[alt*="Primary"]');
  const thumbnails = document.querySelectorAll('div[class*="aspect-square"] img, .gallery-thumbnail');
  if (!mainImage || thumbnails.length === 0) return;

  thumbnails.forEach(thumb => {
    const parent = thumb.parentElement;
    parent.addEventListener('click', () => {
      mainImage.src = thumb.src;
      thumbnails.forEach(t => {
        t.parentElement.classList.remove('ring-white/20');
        t.parentElement.classList.add('ring-white/10');
      });
      parent.classList.add('ring-white/20');
      parent.classList.remove('ring-white/10');
    });
  });
}

/**
 * 7. Product variant selector styling toggles
 */
function initProductVariants() {
  const sizeBtns = document.querySelectorAll('.size-selector-btn');
  const finishBtns = document.querySelectorAll('.finish-selector-btn');

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => {
        b.classList.remove('border-primary', 'bg-primary', 'text-surface', 'font-bold');
        b.classList.add('border-white/20');
      });
      btn.classList.remove('border-white/20');
      btn.classList.add('border-primary', 'bg-primary', 'text-surface', 'font-bold');
      
      const sizeInput = document.querySelector('input[name="properties[Size]"]');
      if (sizeInput) sizeInput.value = btn.getAttribute('data-size');
    });
  });

  finishBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      finishBtns.forEach(b => {
        b.classList.remove('border-primary');
        b.classList.add('border-white/10', 'opacity-60');
      });
      btn.classList.remove('border-white/10', 'opacity-60');
      btn.classList.add('border-primary');

      const finishInput = document.querySelector('input[name="properties[Finish]"]');
      if (finishInput) finishInput.value = btn.getAttribute('data-finish');
    });
  });
}

/**
 * 8. Ajax Cart Drawer and Standalone Cart Interactions
 */
function initCartDrawer() {
  const overlay = document.querySelector('.cart-drawer-overlay');
  const drawer = document.querySelector('.cart-drawer');
  const bagBtns = document.querySelectorAll('.shopping-bag-trigger');
  const closeBtn = document.querySelector('.cart-drawer-close');

  if (!drawer || !overlay) return;

  function openDrawer() {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Open triggers
  bagBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

  // Close triggers
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  window.openEloriaCartDrawer = openDrawer;
}
